<template>
  <div class="bg-white shadow-md rounded-xl p-4 w-full flex flex-col justify-between">
    <!-- Header Section -->
    <div class="flex justify-between items-center">
      <p class="text-gray-900 font-semibold text-lg">Total Training Hours</p>
      <select v-model="selectedMonth" @change="handleMonthChange"
          class="border border-gray-300 text-gray-700 px-2 py-1 rounded-md focus:outline-none focus:ring focus:border-gray-400 bg-white text-sm">
          <option v-for="month in months" :key="month" :value="month">{{ month }}</option>
      </select>
    </div>

    <div class="flex justify-between items-center">
      <div class="mt-4">
        <div v-if="loading" class="animate-pulse h-8 w-32 bg-gray-200 rounded mb-2"></div>
        <p v-else class="text-3xl font-bold text-gray-900">
          {{ hours }}
          <span 
            :class="percentageClass" 
            class="text-sm inline-flex items-center ml-2"
          >
            {{ percentageDirection }} {{ Math.abs(percentage) }}%
          </span>
        </p>
        <p class="text-gray-400 text-sm mt-1">
          {{ changeDirection }} than last week
        </p>
      </div>

      <!-- Chart Image -->
      <div class="mt-4 flex justify-end">
        <img :src="chartImageSrc" alt="Training Hours Chart" class="w-20 h-auto" />
      </div>
    </div>
  </div>
</template>

<script>
import Api from "../../../router/api"; // Adjust the import path as needed

export default {
  name: 'TotalTrainingHours',
  data() {
    return {
      selectedMonth: 'Jan',
      hours: 0,
      percentage: 0,
      loading: true,
      months: [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
      ]
    }
  },
  computed: {
    percentageDirection() {
      return this.percentage >= 0 ? '↑' : '↓';
    },
    percentageClass() {
      return this.percentage >= 0 ? 'text-green-500' : 'text-red-500';
    },
    changeDirection() {
      return this.percentage >= 0 ? 'increased' : 'decreased';
    },
    chartImageSrc() {
      return this.percentage >= 0 
        ? require('@/assets/chart-placeholder.png') 
        : require('@/assets/red-chart.svg');
    }
  },
  methods: {
    handleMonthChange() {
      this.loading = true;
      Api.getTotalVisitingHours({ time_period: this.selectedMonth })
        .then(res => {
          this.hours = res.data.total_visiting_hours;
          this.percentage = res.data.increase_percentage || 0;
          this.loading = false;
        })
        .catch((error) => {
          console.error('Error fetching training hours:', error);
          this.hours = 0;
          this.percentage = 0;
          this.loading = false;
        });
    }
  },
  mounted() {
    // By default, set to current month
    const currentDate = new Date();
    this.selectedMonth = this.months[currentDate.getMonth()];
    this.handleMonthChange();
  }
}
</script>


// WEBPACK FOOTER //
// src/components/admin/dashboard1/TotalTranningHours.vue